import React, { useId } from "react";
import PropTypes from "prop-types";

/**
 * 開關 — 模板 `/form-advanced` 的 CSS Switch(`scss/custom/plugins/_switch.scss`)。
 *
 * 標記與 Admin `pages/Forms/Advanced.js` 同一套:隱藏 `input[switch]` + 相鄰
 * `label[data-on-label][data-off-label]`。點擊走 label `htmlFor`,不要自己攔截
 * click,也不要把 input 設 readOnly(那條路點 pill 切不了、會卡在 Off)。
 *
 *   <Switch text="合約管理－合約金額" checked={on} onChange={setOn} />
 */
export const Switch = ({
  label, text, checked = false, onChange, readOnly = false, disabled = false,
  onLabel = "On", offLabel = "Off", color = "none", id,
}) => {
  const autoId = useId();
  const inputId = id || `switch-${autoId}`;
  const locked = readOnly || disabled;
  const name = label || (typeof text === "string" ? text : undefined);

  return (
    <span className={`dck-switch${locked ? " is-locked" : ""}`}>
      <input
        ref={(el) => {
          if (el) el.setAttribute("switch", color || "none");
        }}
        type="checkbox"
        id={inputId}
        checked={checked}
        disabled={locked}
        onChange={(e) => onChange && onChange(e.target.checked)}
        aria-label={name}
      />
      <label htmlFor={inputId} data-on-label={onLabel} data-off-label={offLabel} />
      {text ? <label htmlFor={inputId} className="dck-switch-text">{text}</label> : null}
    </span>
  );
};

Switch.propTypes = {
  label: PropTypes.string,
  text: PropTypes.node,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  onLabel: PropTypes.string,
  offLabel: PropTypes.string,
  color: PropTypes.string,
  id: PropTypes.string,
};

export default Switch;
